/* global importName */
import store from '@/services/store'
import { getDeepProperty } from '@/helpers/deepObject.js'

const MaeLayout = () => importName('@/scenes/Mae/components/MaeParent.vue', 'mae-layout')
const CampaignList = () => importName('@/scenes/Mae/scenes/CampaignList/CampaignList.vue', 'campaignList')
const CampaignNew = () => importName('@/scenes/Mae/scenes/CampaignNew/CampaignNew.vue', 'campaignNew')
const Markers = () => importName('@/scenes/Mae/scenes/Markers/Markers.vue', 'markers')

const routes = [
  {
    // /accounts/:accountId/campaigns
    path: 'campaigns',
    component: MaeLayout,
    children: [
      {
        path: '/',
        name: 'campaigns',
        redirect: 'library'
      },
      // /accounts/:accountId/campaigns/library
      {
        path: 'library',
        name: 'library',
        component: CampaignList,
        meta: {
          sidebar: true,
          breadcrumbs: () => [
            { title: 'Campaigns' },
            { title: 'Library' }
          ]
        },
        beforeEnter: async (to, from, next) => {
          const adswizz = getDeepProperty(store.getters.featureFlags, 'injector_urls_20200622')
          if (adswizz) {
            next({
              name: 'markers',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      // /accounts/:accountId/campaigns/new
      {
        path: 'new',
        name: 'campaign-new',
        component: CampaignNew,
        meta: {
          sidebar: false,
          breadcrumbs: () => [
            { title: 'Campaigns', to: 'library' },
            { title: 'New Campaign' }
          ]
        },
        beforeEnter: async (to, from, next) => {
          const adswizz = getDeepProperty(store.getters.featureFlags, 'injector_urls_20200622')
          if (adswizz) {
            next({
              name: 'markers',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      // /accounts/:accountId/campaigns/:campaignId/edit
      {
        path: ':campaignId/edit',
        name: 'campaign-edit',
        component: CampaignNew,
        props: true,
        meta: {
          sidebar: false,
          breadcrumbs: () => [
            { title: 'Campaigns', to: 'library' },
            { title: 'Edit Campaign' }
          ]
        },
        beforeEnter: async (to, from, next) => {
          const adswizz = getDeepProperty(store.getters.featureFlags, 'injector_urls_20200622')
          if (adswizz) {
            next({
              name: 'markers',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      // /accounts/:accountId/campaigns/markers
      {
        path: 'markers',
        name: 'markers',
        component: Markers,
        meta: {
          sidebar: true,
          breadcrumbs: () => [
            { title: 'Campaigns' },
            { title: 'Markers' }
          ]
        }
      }
    ],
    beforeEnter: async (to, from, next) => {
      // if a user is not allowed to edit campaigns, no campaigns pages for them!
      let currentAccount = store.getters.currentAccount
      const hasCampaigns = (
        getDeepProperty(currentAccount, 'features.has_campaigns') &&
        getDeepProperty(currentAccount, 'permission.campaign_permission.can_edit')
      )
      if (!hasCampaigns) {
        next({
          name: 'all-shows',
          params: {
            accountId: getDeepProperty(to, 'params.accountId')
          }
        })
        return
      }
      next()
    }
  }
]

export default routes
